// import Web3 from "web3";

import { readContract, waitForTransaction, writeContract } from "@wagmi/core";
import { toast } from "react-hot-toast";
import {
  MultisendContract,
  MultisendContractAbi,
} from "../../../../config/config";

const coreCrowed = {
  abi: MultisendContractAbi,
  address: MultisendContract,
};

export async function lapseWallet() {
  const result = await readContract({
    ...coreCrowed,
    functionName: "lapseWallet",
  });
  return result;
}

export async function setLapseWallet(address) {
  const result = await writeContract({
    ...coreCrowed,
    functionName: "setLapseWallet",
    args: [address],
  });
  const res = waitForTransaction(result);
  const data = await toast.promise(res, {
    loading: "Txn is pending...",
    success: "Lapse Wallet Changed successfully!",
    error: (error) => error.message ?? "request failed.",
  });
  return data;
}
